var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.216 12.91V1.087C11.216.489 10.73 0 10.129 0H3.87c-.598 0-1.087.486-1.087 1.087v11.826c0 .598.486 1.087 1.087 1.087h6.258a1.093 1.093 0 001.087-1.09zM3.485 2.52h7.027v7.956H3.485V2.52zM3.871.7h6.258c.212 0 .386.172.386.387v.732h-7.03v-.732c0-.215.174-.386.386-.386zm-.386 12.21v-1.736h7.027v1.736a.386.386 0 01-.386.386H3.871a.386.386 0 01-.386-.386z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71 11.915H6.287a.352.352 0 100 .704h1.421a.352.352 0 100-.704z",
    fill: "#949494"
  })));
}

export default __webpack_public_path__ + "./fonts/mobile.8c7d5c3ff31b177f7992f60aedacea61.svg";
export { SvgMobile as ReactComponent };